var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWidgetsEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 110,
    viewBox: "0 0 160 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.827 100.016H5.14135C2.48154 100.016 0.325348 101.09 0.325348 102.416C0.325348 103.741 2.48154 104.816 5.14135 104.816H154.827C157.486 104.816 159.643 103.741 159.643 102.416C159.643 101.09 157.486 100.016 154.827 100.016Z",
    fill: "#24285B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5493 71.957H75.136V100.016H94.5493V71.957Z",
    fill: "#FFD200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4053 84.4854H48.992V100.016H68.4053V84.4854Z",
    fill: "#FFD200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8933 92.251H22.48V100.016H41.8933V92.251Z",
    fill: "#FFD200"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.149 53.4404H100.736V100.016H120.149V53.4404Z",
    fill: "#FFD200"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.661 32.7412H125.248V100.016H144.661V32.7412Z",
    fill: "#FFD200"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2827 70.0591C30.2827 70.0591 75.488 64.9604 99.2 29.7871L110.464 38.6404C110.464 38.6404 74.6667 76.5978 30.2827 70.0591Z",
    fill: "#6868FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9333 26.747L113.856 44.235L118.245 19.291L92.9333 26.747Z",
    fill: "#6868FE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.776 50.3523C45.6317 50.3523 55.2426 40.7413 55.2426 28.8856C55.2426 17.0299 45.6317 7.41895 33.776 7.41895C21.9203 7.41895 12.3093 17.0299 12.3093 28.8856C12.3093 40.7413 21.9203 50.3523 33.776 50.3523Z",
    fill: "#E6E6E6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.776 7.41309V28.8851L52.976 19.2851C52.976 19.2851 48.432 7.86642 33.776 7.41309Z",
    fill: "#C1C1C1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M44.2827 19.1038C45.2989 19.1038 46.1227 18.28 46.1227 17.2638C46.1227 16.2476 45.2989 15.4238 44.2827 15.4238C43.2665 15.4238 42.4427 16.2476 42.4427 17.2638C42.4427 18.28 43.2665 19.1038 44.2827 19.1038Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.776 28.8857L55.1413 30.9817C55.1413 30.9817 56.0693 25.7177 53.008 19.291L33.776 28.8857Z",
    fill: "#AFAFAF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.776 28.8857L53.376 37.6431C54.4593 35.5842 55.0628 33.3069 55.1413 30.9817L33.776 28.8857Z",
    fill: "#999999"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.776 28.8857L50.4907 42.3471C50.4907 42.3471 52.576 39.8244 53.376 37.6431L33.776 28.8857Z",
    fill: "#848484"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4587 17.4881C44.3944 17.4878 44.3321 17.4652 44.2827 17.4241C44.2373 17.3765 44.2106 17.3141 44.2077 17.2484C44.2047 17.1827 44.2257 17.1182 44.2667 17.0668L54.1813 5.33343C54.2051 5.30247 54.2358 5.27762 54.2711 5.26092C54.3063 5.24423 54.345 5.23617 54.384 5.23743H67.184C67.2547 5.23743 67.3225 5.26553 67.3726 5.31554C67.4226 5.36555 67.4507 5.43337 67.4507 5.5041C67.4507 5.57482 67.4226 5.64265 67.3726 5.69266C67.3225 5.74267 67.2547 5.77077 67.184 5.77077H54.5067L44.6613 17.3921C44.6368 17.4221 44.6059 17.4463 44.5708 17.4629C44.5358 17.4795 44.4975 17.4881 44.4587 17.4881Z",
    fill: "#24285B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0667 0.335938H64.3253V10.6826H87.0667V0.335938Z",
    fill: "#24285B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3414 7.44034H84.9014L82.6187 3.15234L80.3414 7.44034Z",
    fill: "#6868FE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.392 3.32812H69.7707C69.3936 3.32812 69.088 3.63257 69.088 4.00812C69.088 4.38368 69.3936 4.68812 69.7707 4.68812H77.392C77.769 4.68812 78.0747 4.38368 78.0747 4.00812C78.0747 3.63257 77.769 3.32812 77.392 3.32812Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M77.392 5.91992H69.7707C69.3936 5.91992 69.088 6.22437 69.088 6.59992C69.088 6.97548 69.3936 7.27992 69.7707 7.27992H77.392C77.769 7.27992 78.0747 6.97548 78.0747 6.59992C78.0747 6.22437 77.769 5.91992 77.392 5.91992Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetsEmptyState);
export default __webpack_public_path__ + "static/media/widgets_empty_state.02d114e030480e199fe4b2780166faf3.svg";
export { ForwardRef as ReactComponent };